import { useMutation } from '@tanstack/react-query';
import { transcribeAudio, TranscribeAudioParams } from '../../services/backendService';

export const useSpeechToText = () => {
  return useMutation({
    mutationKey: ['transcribeAudio'],
    mutationFn: (params: TranscribeAudioParams) => transcribeAudio(params),
  });
};
